import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

const FechaVencimientoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('productoSelect', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FEC. VENCIMIENTO' htmlFor='date-fechaVencimiento' md={6} alignRightAt='md' />
      <Col md={6}>
        <Field name='fechaVencimiento'>
          {({ field }) => (
            <Form.InputDate {...field} id='date-fechaVencimiento' disabled={fIsSubmitting} isInvalid={iTouched && iError} onKeyDown={onKeyDown} />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaVencimientoFormGroup)
